import Vue from "vue";
import titleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { fromText as getOwnerTypeFromText } from "@/types/attachmentTypes/AttachmentOwnerType";
import AttachmentAvailabilityWrapper from "@/components/Attachments/AttachmentAvailabilityWrapper.vue";
Vue.use(UploaderPlugin);
export default Vue.extend({
    components: { AttachmentAvailabilityWrapper },
    mixins: [titleMixin, SpinnerMixin],
    data() {
        return {
            title: this.$t("attachments.edit.title"),
            attachment: {
                attachmentTypeId: null,
                name: "",
                fileName: "",
                fileContent: ""
            },
            attachmentTypes: [],
            validationOptions: {
                rules: {
                    attachmentTypeId: {
                        required: true
                    },
                    name: {
                        required: true
                    },
                    fileName: {
                        required: true
                    }
                }
            }
        };
    },
    methods: {
        attachmentSelected(args) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const fileContent = reader.result != null ? reader.result.toString() : null;
                if (fileContent != null) {
                    const fileContentParts = fileContent.split(";base64,");
                    this.attachment.fileName = args.filesData[0].name;
                    this.attachment.fileContent = fileContentParts.length == 2 ? fileContentParts[1] : fileContent;
                }
            };
            reader.readAsDataURL(args.filesData[0].rawFile);
        },
        getAttachment() {
            switch (this.$route.params.ownerType) {
                case "customers":
                    return this.$store.dispatch("customer/getAttachment", {
                        id: this.$route.params.id,
                        customerId: this.$route.params.ownerId
                    });
                case "employees":
                    return this.$store.dispatch("employee/getAttachment", {
                        id: this.$route.params.id,
                        employeeId: this.$route.params.ownerId
                    });
                default:
                    throw new Error(`The owner type '${this.$route.params.ownerType}' is not managed.`);
            }
        },
        edit() {
            switch (this.$route.params.ownerType) {
                case "customers":
                    return this.$store.dispatch("customer/editAttachment", {
                        id: this.attachment.id,
                        customerId: this.$route.params.ownerId,
                        attachment: this.attachment
                    });
                case "employees":
                    return this.$store.dispatch("employee/editAttachment", {
                        id: this.attachment.id,
                        employeeId: this.$route.params.ownerId,
                        attachment: this.attachment
                    });
                default:
                    throw new Error(`The owner type '${this.$route.params.ownerType}' is not managed.`);
            }
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("attachments.edit.toastSuccessTitle"), this.$t("attachments.edit.toastSuccessContent", {
                name: this.attachment.name
            }));
            return this.$router.push(`/${this.$route.params.ownerType}/${this.$route.params.ownerId}/attachments`);
        },
        cancel() {
            return this.$router.push(`/${this.$route.params.ownerType}/${this.$route.params.ownerId}/attachments`);
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            const ownerType = getOwnerTypeFromText(this.$route.params.ownerType);
            this.attachmentTypes = await this.$store.dispatch("attachmentType/getAll", { ownerType: ownerType });
            this.attachment = await this.getAttachment();
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push(`${this.$route.params.ownerType}/${this.$route.params.ownerId}/attachments/`);
        }
        finally {
            this.hideSpinner();
        }
    }
});
